/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row1_MulticaInputs */

const en_mk_cmp_row1_multica = /** @type {(inputs: Mk_Cmp_Row1_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A daemon on your machine, needs a CLI`)
};

const id_mk_cmp_row1_multica = /** @type {(inputs: Mk_Cmp_Row1_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daemon di komputermu, butuh CLI`)
};

/**
* | output |
* | --- |
* | "A daemon on your machine, needs a CLI" |
*
* @param {Mk_Cmp_Row1_MulticaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row1_multica = /** @type {((inputs?: Mk_Cmp_Row1_MulticaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row1_MulticaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row1_multica(inputs)
	return en_mk_cmp_row1_multica(inputs)
});